import { React, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import PrimaryButton from "../../../../../components/PrimaryButton";
import { Link } from "react-router-dom";
import { DataGrid } from "@material-ui/data-grid";
import Fade from "@material-ui/core/Fade";

const useStyles = makeStyles((theme) => ({
  searchBar: {
    width: "70%",
    backgroundColor: "white",
    marginLeft: "3%",
    marginTop: "2%",
  },
  formControl: {
    margin: theme.spacing(1),
    marginLeft: "3%",
    marginTop: "2%",
    minWidth: 120,
    backgroundColor: "white",
    width: "15%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  nextButton: {
    float: "right",
    marginRight: "8%",
    marginTop: "2%",
  },
  results: {
    marginTop: "2%",
    height: "50%",
    overflow: "scroll",
    color: theme.palette.text.primary,
  },
}));

const columns = [
  { field: "id", headerName: "ID", width: 70 },
  { field: "name", headerName: "Name", width: 200 },
  { field: "year", headerName: "Year", width: 130 },
  { field: "description", headerName: "Description", width: 300 },
  { field: "size", headerName: "Size", width: 130 },

  { field: "origin", headerName: "Origin", width: 150 },
];

const rows = [
  {
    id: 1,
    name: "Diabetes",
    year: "2017",
    description: "Diabetes prediction data of female Pima Indians",
    size: "768 samples",
    origin: "NIH",
  },
  {
    id: 2,
    name: "ProteinNet2016",
    year: "2016",
    description: "CASP12 protein sequences",
    size: "146 samples",
    origin: "CASP",
  },
  {
    id: 3,
    name: "ProteinNet2018",
    year: "2018",
    description: "CASP13 protein sequences",
    size: "193 samples",
    origin: "CASP",
  },
  {
    id: 4,
    name: "Tox21",
    year: "2016",
    description: "Chemical compounds",
    size: "12,707 samples",
    origin: "JKU",
  },
  {
    id: 5,
    name: "Prostate cancer",
    year: "2018",
    description: "Whole genome and transcriptome sequencing",
    size: "292 samples",
    origin: "DFKZ",
  },
];

const Search = (props) => {
  const classes = useStyles();
  const [sort, setSort] = useState("");

  const handleChange = (event) => {
    setSort(event.target.value);
  };

  const keepSelectedDatasets = (e) => {
    sessionStorage.setItem("dataset", e.data.name);
    //setDatasetState(configJSON.selectedDatasets);
  };

  return (
    <Fade in={true}>
      <>
        <div>
          <TextField
            id="outlined-basic"
            label="Search datasets..."
            variant="outlined"
            className={classes.searchBar}
          />
          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel id="demo-simple-select-outlined-methods">
              Sort By
            </InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-methods"
              value={sort}
              onChange={handleChange}
              label="Sort By"
            >
              <MenuItem value={10}>Date</MenuItem>
              <MenuItem value={20}>Alphabetical</MenuItem>
              <MenuItem value={30}>Usage</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className={classes.results}>
          <div style={{ height: 450, width: "88%", marginLeft: "3%" }}>
            <DataGrid
              rows={rows}
              columns={columns}
              pageSize={5}
              checkboxSelection
              onRowSelected={keepSelectedDatasets}
            />
          </div>
        </div>

        <Link to="/methods/new-method/features">
          <PrimaryButton innerText="Next" styleClasses={classes.nextButton} />
        </Link>
      </>
    </Fade>
  );
};

export default Search;
